import { useEffect, useState, useCallback } from "react";
import { fetchVisitors } from "../lib/apiClient";
import { useEvent } from "../contexts/EventContext";

export function useVisitors() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { eventDate, eventTableKey } = useEvent();

  const clear = useCallback(() => {
    setRows([]);
    setError("");
    setLoading(false);
  }, []);

  const search = useCallback(async () => {
    let alive = true;
    try {
      setLoading(true);
      setError("");

      const res = await fetchVisitors(eventDate, eventTableKey);

      if (!alive) return;

      const raw = res.data ?? [];

      const mapped = raw.map((r) => ({
        synergy_id: r.synergy_id ?? "",
        visitor_name: r.visitor_name ?? "",
        visitor_name_kana: r.visitor_name_kana ?? "",
        company_name: r.company_name ?? "",
        department_name: r.department_name ?? "",
        position_name: r.position_name ?? "",
        postal_code: r.postal_code ?? "",
        prefecture: r.prefecture ?? "",
        municipality: r.municipality ?? "",
        address: r.address ?? "",
        building_name: r.building_name ?? "",
        phone_number: r.phone_number ?? "",
        industry: r.industry ?? "",
        event_source: r.event_source ?? "",
        event_source_agency_text: r.event_source_agency_text ?? "",
        event_source_other_text: r.event_source_other_text ?? "",
        invitation_from: r.invitation_from ?? "",
        preferred_visit_date: r.preferred_visit_date ?? "",
        visit_transportation: r.visit_transportation ?? "",
        visit_transportation_other_text: r.visit_transportation_other_text ?? "",
        applied_at: r.applied_at ?? "",
        event_name: r.event_name ?? "",
        applied_seminars: r.applied_seminars ?? "",
        visited: r.visited === "true" || r.visited === true,
      }));

      setRows(mapped);

      // if (alive) setRows(res.data ?? []);
    }
    catch (e) {
      if (alive) setError(String(e));
    }
    finally {
      if (alive) setLoading(false);
    }
  }, [eventDate, eventTableKey]);

  return { rows, loading, error, search, clear };
}
